module.exports = "<bdb-ml-modal\n    #modal\n    icon=\"error\"\n    [titleModal]=\"modalData?.title\"\n    [subTitle]=\"modalData?.subtitle\"\n    [optionsButtons]=\"modalOptions\"\n    (buttonAlertClicked)=\"handleButtonClick($event)\"\n></bdb-ml-modal>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bdb-error-v2-modal/bdb-error-v2-modal.component.html
// module id = ./src/app/bdb-error-v2-modal/bdb-error-v2-modal.component.html
// module chunks = main